var hostname = window.location.hostname;
var isProd = hostname === 'snail-na.qcplay.com';
// var disable = isProd ? false : true;
window.__bl = {
    config: {
        pid: "egrrccpv71@52097f6881c33dd",
        appType: "web",
        imgUrl: "https://arms-retcode.aliyuncs.com/r.png?",
        sendResource: true,
        enableLinkTrace: true,
        behavior: true,
        disabled: false,
        environment: isProd ? 'prod' : 'local',
        page: window.pageName,
    }
}